module.exports = {"320104001":"秦虹街道","320104002":"夫子庙街道","320104003":"红花街道","320104004":"双塘街道","320104005":"中华门街道","320104006":"五老村街道","320104007":"洪武路街道","320104008":"大光路街道","320104009":"瑞金路街道","320104010":"月牙湖街道","320104011":"光华路街道","320104012":"朝天宫街道","320104400":"夫管办","320104401":"高新园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320104.json
// module id = 764
// module chunks = 0